import {Component, ElementRef, Inject, OnInit, ViewChild} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from "@angular/material/dialog";
import {ActivatedRoute, Router} from "@angular/router";

import {AuthorizationService} from "../../../../../../services/authorization.service";
import {CartService} from "../../../../services/cart.service";
import {RegistryService} from "../../../../services/registry.service";
import {PaymentService} from "../../../../services/payment.service";
import {PaymentMethod} from "../../../../models/CartModels/Checkout/PaymentMethod";
import {GoogleAnalyticsService} from "../../../../services/google-analytics.service";

@Component({
    selector: 'app-order-progress-dialog',
    templateUrl: './order-progress-dialog.component.html',
    styleUrls: ['./order-progress-dialog.component.css']
})
export class OrderProgressDialogComponent implements OnInit {

    opmessage = "Please wait while we process your order.."

    constructor(
        private router: Router,
        private cartService: CartService,
        private paymentService: PaymentService,
        private registry: RegistryService,
        private googleService: GoogleAnalyticsService,
        private route: ActivatedRoute, private authorize: AuthorizationService,
        @Inject(MAT_DIALOG_DATA) public data: any,
        private dialogRef: MatDialogRef<OrderProgressDialogComponent>
    ) {
    }

    ngOnInit(): void {
        this.placeOrder();
    }

    placeOrder() {


        if (this.cartService.isCheckOrderReady()) {
            this.cartService.placeOrder(this.cartService.selectedShippingAddress, this.cartService.selectedPaymentMethod).subscribe(result => {
                this.googleService.eventEmitter("order_placed", 'checkout', 'order_placed', this.cartService.lastOrderId);

                //order places successfully.
                this.cartService.lastOrderId = result;
                this.opmessage = 'You will be redirected to complete your order payment ... please wait';
                //do post process operation
                // this.cartService.resetOrderSelections();
                // this.summary = null;
                this.cartService.createCustomerCart().subscribe(result => {
                    this.registry.setupCustomer().subscribe(result => {

                        this.redirectToPaymentPage(this.cartService.lastOrderId, this.cartService.selectedPaymentMethod);

                    })
                })


            });

        } else {
            //add a notification.
        }
    }


    redirectToPaymentPage(orderId, paymentMethod: PaymentMethod) {

        switch (paymentMethod.code) {

            case 'knet':
                this.dialogRef.close();
                this.router.navigateByUrl('web/payment/knet/' + orderId);


                break;

            case 'banktransfer':
                this.dialogRef.close();
                this.router.navigateByUrl('web/payment/banktransfer/' + orderId);

                break;


            case 'mastercardpayment':
                this.dialogRef.close();
                this.router.navigateByUrl('web/payment/mc/' + orderId);

                break;

        }

    }

}
